const tokenVersion = "v1";
const tokenKey = "regulator-shared-profile-checksum-v1";

export async function createShareToken() {
  const random = crypto.getRandomValues(new Uint8Array(24));
  return `${tokenVersion}.${base64Url(random)}.${base64Url(await checksum(random))}`;
}

export async function validShareToken(token) {
  const [version, encodedRandom, encodedChecksum, extra] = String(token ?? "").split(".");
  if (version !== tokenVersion || !encodedRandom || !encodedChecksum || extra) return false;
  try {
    const random = fromBase64Url(encodedRandom);
    const supplied = fromBase64Url(encodedChecksum);
    if (random.length !== 24 || supplied.length !== 12) return false;
    const expected = await checksum(random);
    return expected.every((byte, index) => byte === supplied[index]);
  } catch {
    return false;
  }
}

async function checksum(random) {
  const key = await crypto.subtle.importKey("raw", new TextEncoder().encode(tokenKey), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
  const signature = await crypto.subtle.sign("HMAC", key, random);
  return new Uint8Array(signature).slice(0, 12);
}

function base64Url(bytes) {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
}

function fromBase64Url(value) {
  const base64 = value.replaceAll("-", "+").replaceAll("_", "/");
  const binary = atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "="));
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
}
